import React from 'react';

import './Loader.css';

const Loader = () => <div className="Loader"></div>;

export default Loader;
